import ImpactPill from "@/components/Impact/ImpactPill";
import Table, { Column } from "@/components/Table/Table";
import { ReactNode } from "react";
import { BomItemCompare } from "../../../useProducts";
import BomRowCompare from "./BomRowCompare";

export default function BillOfMaterialsCompareTable({
  data,
  loading,
  noDataMessage,
}: {
  data?: BomItemCompare;
  loading?: boolean;
  noDataMessage?: ReactNode;
}) {
  const columns: Column<BomItemCompare>[] = [
    {
      key: "name",
      label: "Material",
      minWidth: "250px",
      maxWidth: "250px",
    },
    {
      key: "total_mass",
      label: "Total mass (kg)",
      minWidth: "100px",
    },
    {
      key: "impact",
      label: "Impact",
      minWidth: "240px",
      renderer: (record) => (
        <ImpactPill
          loading={false}
          impact={record.impact}
          type="borderless"
          showDate={false}
          incomplete={record.status === "incomplete"}
          incompleteTooltip={
            record.status === "incomplete"
              ? "Material needs an impact reference and/or unit conversion to calculate impact."
              : undefined
          }
        />
      ),
    },
  ];

  const bomData = data?.children.sort((a, b) => {
    if (a.children.length > b.children.length) return 1;
    if (a.children.length < b.children.length) return -1;
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  });

  return (
    <Table<BomItemCompare>
      loading={loading}
      rowKey="id"
      data={bomData}
      columns={columns}
      rowRenderer={BomRowCompare}
      rowLink={(record) => "/materials/" + record.id}
      emptyState={{
        noResultsMessage: noDataMessage || "No bill of materials available.",
      }}
    />
  );
}
